const types = {
    SET_PROVIDER_LIST: '[PROVIDER] SET PROVIDER LIST',
    SET_SEARCH_LIST: '[PROVIDER] SET SEARCH LIST',
}

export {
    types,
}